<template>
  <div
    id="document-actionbar-search-view"
    class="flex py-1 items-center content-center"
  >
    <div>検索範囲</div>
    <vs-radio
      class="ml-4"
      v-model="searchRange"
      vs-name="search-range"
      vs-value="all"
      :color="AISEA_COLOR.BLUE"
      >すべて</vs-radio
    >
    <vs-radio
      class="ml-4"
      v-model="searchRange"
      vs-name="search-range"
      vs-value="current"
      :color="AISEA_COLOR.BLUE"
    >
      <vx-tooltip :text="currentFolder" class="max-w-xs truncate ...">
        {{ currentFolder }}
      </vx-tooltip>
    </vs-radio>
  </div>
</template>

<script>
import { ColorMixin } from "@/mixins";
import { createNamespacedHelpers } from "vuex";

const {
  mapMutations: mapMutationsOfenterpriseDocumentManager,
  mapState: mapStateOfenterpriseDocumentManager
} = createNamespacedHelpers("enterpriseDocumentManager");

export default {
  mixins: [ColorMixin],
  data () {
    return {
    }
  },
  computed: {
    ...mapStateOfenterpriseDocumentManager([
      "searchDocumentsRange",
      "vesselName",
      "currentPath"
    ]),
    searchRange: {
      get () {
        return this.searchDocumentsRange
      },
      set (payload) {
        this.SET_SEARCH_DOCUMENTS_RANGE(payload)
      }
    },
    currentFolder () {
      if (this.currentPath.length === 0) return this.vesselName
      return this.currentPath.slice(-1)[0].name
    },
  },
  methods: {
    ...mapMutationsOfenterpriseDocumentManager(["SET_SEARCH_DOCUMENTS_RANGE"]),
  },
  watch: {
    searchRange (payload = "current") {
      this.SET_SEARCH_DOCUMENTS_RANGE(payload)
    },
  }
}
</script>

<style>
</style>